import { useState } from 'react';
import { faqs } from '@/mocks/home';

export default function Faq() {
  const [activeId, setActiveId] = useState<string | null>(faqs[0]?.id ?? null);

  return (
    <section id="faq" className="scroll-mt-20 border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">常见问题</h2>
            <p className="mt-3 text-sm leading-7 text-foreground-700">
              关于黑料入口跳转、秒进与直达链接最常被问到的几件事，看完基本就不用再问了。
            </p>
          </div>

          <div className="lg:col-span-8">
            <ul className="divide-y divide-background-200 border-y border-background-200">
              {faqs.map((item) => {
                const isOpen = activeId === item.id;
                return (
                  <li key={item.id}>
                    <button
                      type="button"
                      onClick={() => setActiveId(isOpen ? null : item.id)}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 py-4 text-left"
                    >
                      <span className="text-sm text-foreground-950 md:text-base">{item.q}</span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition ${
                          isOpen
                            ? 'border-primary-300 bg-primary-100 text-primary-700'
                            : 'border-background-300 text-foreground-500'
                        }`}
                      >
                        <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i>
                      </span>
                    </button>
                    {isOpen && (
                      <p className="-mt-1 pb-4 pr-10 text-sm leading-7 text-foreground-600">{item.a}</p>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}